import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const DashboardPage = () => {
  const intl = useIntl()

  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]} description=''>
        {intl.formatMessage({id: 'SLIDEMENU.HOME'})}
      </PageTitle>

      {/* begin::Row */}
      <div className='container'>
        <div className='row g-5 g-xl-8 mt-lg-n16 mt-2'>
          <div className='col'>
            <div className='row d-flex justify-content-center align-items-center'>
              <p className='fs-1 text-center fw-bolder text-dark mb-10'>Welcome to Management</p>
              <img
                className='mx-auto h-350px'
                src={toAbsoluteUrl('/media/illustrations/misc/management-home.svg')}
                alt='Management Home'
              />
            </div>
          </div>
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const ManagementDashboard = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'SLIDEMENU.HOME'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {ManagementDashboard}
